import { DfButtonsModule } from '@lib/fresco';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WebEnvironmentService } from '@dg/shared-services';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, DfButtonsModule],
})
export class DgxLoggedOutComponent {
  public i18n = this.translate.instant([
    'AccountController_LoggedOutHeader',
    'AccountController_LoginAgainButton',
  ]);

  public get degreedGlassesLogo(): string {
    return this.webEnvironmentService.getBlobUrl(
      '/content/img/public/login/new-glasses.svg',
      true
    );
  }

  public get headerText(): string {
    return this.i18n.AccountController_LoggedOutHeader;
  }

  public get buttonLabel(): string {
    return this.i18n.AccountController_LoginAgainButton;
  }

  public get loginUrl(): string {
    const searchParams = new URLSearchParams(window.location.search).toString();
    const queryString = searchParams.length > 0 ? `?${searchParams}` : '';
    return '/account/login' + queryString;
  }

  constructor(
    private translate: TranslateService,
    private webEnvironmentService: WebEnvironmentService
  ) {}
}
